import PropTypes from "prop-types"
import intl from 'react-intl-universal'
import Dialog from "material-ui/Dialog"
import { ModalText, ModalTextAttention, ModalTitle } from './styled'
import Button from "components/button"

const ModalSuggestionsMassAcceptance = ({
  open,
  close,
  onClick,
  suggestions,
  stockReturnSuggestions,
  suggestionsInOver,
}) => (
  <Dialog
    open={open}
    contentStyle={{ width: "600px" }}
  >
    <ModalTitle>{intl.get('suggestions.messageModalConfirmation')}</ModalTitle>
    {stockReturnSuggestions.length > 0 ? (
      <>
        <ModalText>
          {intl.get('suggestions.messageModalMixedTotal', {
            count: suggestions.length + stockReturnSuggestions.length,
          })}
        </ModalText>
        <ModalText>
          {intl.get('suggestions.messageModalMixedCommon', { count: suggestions.length })}{' '}
          {suggestions.map((suggestion) => suggestion.Id).join(', ')}
        </ModalText>
        <ModalText isLast={suggestionsInOver.length === 0}>
          {intl.get('suggestions.messageModalMixedStockReturns', {
            count: stockReturnSuggestions.length,
          })}{' '}
          {stockReturnSuggestions.map((suggestion) => suggestion.Id).join(', ')}
        </ModalText>
      </>
    ) : (
      <ModalText isLast={suggestionsInOver.length === 0}>
        {suggestions.length} {intl.get('suggestions.messageModalMessage')}{' '}
        {suggestions.map((suggestion) => suggestion.Id).join(', ')}
      </ModalText>
    )}
    {(suggestionsInOver.length > 0) &&
      <ModalTextAttention> {intl.get('suggestions.messageModalAttention')} {suggestionsInOver.map((x) => x.Id).join(', ')} </ModalTextAttention>
    }
    <div className="botoes-modal">
      <Button
        value={intl.get('geral.modalConfirm.no')}
        onClick={close}
        className="btn"
        style={{ width: '150px' }}
      />
      <Button
        buttonType="primary"
        value={intl.get('geral.modalConfirm.yes')}
        onClick={onClick}
        className="btn margin-botao"
        style={{ width: '150px' }}
      />
    </div>
  </Dialog>
)

ModalSuggestionsMassAcceptance.propTypes = {
  close: PropTypes.any.isRequired,
  onClick: PropTypes.any.isRequired,
  open: PropTypes.any.isRequired,
  suggestions: PropTypes.arrayOf(
    PropTypes.shape({
      Id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    }).isRequired
  ).isRequired,
  stockReturnSuggestions: PropTypes.arrayOf(
    PropTypes.shape({
      Id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    }).isRequired
  ),
  suggestionsInOver: PropTypes.arrayOf(
    PropTypes.shape({
      Id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    }).isRequired
  ).isRequired,
}

ModalSuggestionsMassAcceptance.defaultProps = {
  stockReturnSuggestions: [],
};

export default ModalSuggestionsMassAcceptance;
